import { render } from "./AddNotificationPage.vue?vue&type=template&id=d6c81fd6&ts=true"
import script from "./AddNotificationPage.vue?vue&type=script&lang=ts"
export * from "./AddNotificationPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__